'use client'

import AppContext from '@/types/context'
import { useConsentReady } from '@/hooks/useConsentReady'
import { useEffect } from 'react'
import { internalTracking } from '@/libs/Tracking/Tracking.lib'

export default function InternalTracking({ context }: { readonly context: AppContext }) {
  const consentReady = useConsentReady()

  useEffect(() => {
    if (consentReady && context.metadata) {
      internalTracking(context.metadata.model.internalTrackingUrl)
    }
  }, [consentReady])

  return <></>
}
